var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.patGoal)?_c('span',{staticClass:"patient-goal"},[_c('span',{staticClass:"patient-goal-label"},[_vm._v("Goal")]),_c('span',{staticClass:"patient-goal-value"},[_vm._v(_vm._s(_vm.patGoal))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }